var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "register-form" }, [
    _vm.hasError
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fi fi-alert" }),
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage && !_vm.isSettingUp
      ? _c(
          "div",
          { staticClass: "alert alert-success", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fi fi-check" }),
            _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isSettingUp
      ? _c("div", [
          _c(
            "form",
            {
              staticClass: "auth-form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.handleRegister.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userData.first_name,
                        expression: "userData.first_name",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.first_name },
                    attrs: {
                      id: "first_name",
                      type: "text",
                      placeholder: "First Name",
                      required: "",
                      disabled: _vm.isLoading,
                    },
                    domProps: { value: _vm.userData.first_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.userData,
                          "first_name",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.first_name
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errors.first_name[0]) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userData.last_name,
                        expression: "userData.last_name",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.last_name },
                    attrs: {
                      id: "last_name",
                      type: "text",
                      placeholder: "Last Name",
                      required: "",
                      disabled: _vm.isLoading,
                    },
                    domProps: { value: _vm.userData.last_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.userData, "last_name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.last_name
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errors.last_name[0]) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userData.hotel_name,
                      expression: "userData.hotel_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.hotel_name },
                  attrs: {
                    id: "hotel_name",
                    type: "text",
                    placeholder: "Hotel Name",
                    required: "",
                    disabled: _vm.isLoading,
                  },
                  domProps: { value: _vm.userData.hotel_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.userData, "hotel_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.hotel_name
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.hotel_name[0]) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userData.email,
                      expression: "userData.email",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.email },
                  attrs: {
                    id: "email",
                    type: "email",
                    placeholder: "Email",
                    required: "",
                    disabled: _vm.isLoading,
                  },
                  domProps: { value: _vm.userData.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.userData, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.email
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.email[0]) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "password-input-wrapper" }, [
                  (_vm.showPassword ? "text" : "password") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password,
                            expression: "userData.password",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.password },
                        attrs: {
                          id: "password",
                          placeholder: "Create a password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userData.password)
                            ? _vm._i(_vm.userData.password, null) > -1
                            : _vm.userData.password,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.userData.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.userData,
                                    "password",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.userData,
                                    "password",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.userData, "password", $$c)
                            }
                          },
                        },
                      })
                    : (_vm.showPassword ? "text" : "password") === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password,
                            expression: "userData.password",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.password },
                        attrs: {
                          id: "password",
                          placeholder: "Create a password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm._q(_vm.userData.password, null),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.userData, "password", null)
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password,
                            expression: "userData.password",
                          },
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.password },
                        attrs: {
                          id: "password",
                          placeholder: "Create a password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: _vm.showPassword ? "text" : "password",
                        },
                        domProps: { value: _vm.userData.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.userData,
                              "password",
                              $event.target.value
                            )
                          },
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "password-toggle",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: {
                        click: function ($event) {
                          _vm.showPassword = !_vm.showPassword
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.showPassword
                          ? "fi fi-eye-slash"
                          : "fi fi-eye",
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.errors.password
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.password[0]) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "password-requirements",
                    class: { hidden: _vm.allRequirementsMet },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "requirement",
                        class: { met: _vm.passwordMeetsLength },
                      },
                      [
                        _c("i", {
                          class: _vm.passwordMeetsLength
                            ? "fi fi-check"
                            : "fi fi-circle",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("At least 8 characters")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "requirement",
                        class: { met: _vm.passwordMeetsUppercase },
                      },
                      [
                        _c("i", {
                          class: _vm.passwordMeetsUppercase
                            ? "fi fi-check"
                            : "fi fi-circle",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("At least one uppercase letter")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "requirement",
                        class: { met: _vm.passwordMeetsLowercase },
                      },
                      [
                        _c("i", {
                          class: _vm.passwordMeetsLowercase
                            ? "fi fi-check"
                            : "fi fi-circle",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("At least one lowercase letter")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "requirement",
                        class: { met: _vm.passwordMeetsNumber },
                      },
                      [
                        _c("i", {
                          class: _vm.passwordMeetsNumber
                            ? "fi fi-check"
                            : "fi fi-circle",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("At least one number")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "requirement",
                        class: { met: _vm.passwordMeetsSpecial },
                      },
                      [
                        _c("i", {
                          class: _vm.passwordMeetsSpecial
                            ? "fi fi-check"
                            : "fi fi-circle",
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("At least one special character @$!%*?&#"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "password-input-wrapper" }, [
                  (_vm.showConfirmPassword ? "text" : "password") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password_confirmation,
                            expression: "userData.password_confirmation",
                          },
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.password_confirmation,
                        },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: "Confirm your password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.userData.password_confirmation
                          )
                            ? _vm._i(_vm.userData.password_confirmation, null) >
                              -1
                            : _vm.userData.password_confirmation,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.userData.password_confirmation,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.userData,
                                    "password_confirmation",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.userData,
                                    "password_confirmation",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.userData,
                                "password_confirmation",
                                $$c
                              )
                            }
                          },
                        },
                      })
                    : (_vm.showConfirmPassword ? "text" : "password") ===
                      "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password_confirmation,
                            expression: "userData.password_confirmation",
                          },
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.password_confirmation,
                        },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: "Confirm your password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.userData.password_confirmation,
                            null
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.userData,
                              "password_confirmation",
                              null
                            )
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userData.password_confirmation,
                            expression: "userData.password_confirmation",
                          },
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.password_confirmation,
                        },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: "Confirm your password",
                          required: "",
                          disabled: _vm.isLoading,
                          type: _vm.showConfirmPassword ? "text" : "password",
                        },
                        domProps: { value: _vm.userData.password_confirmation },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.userData,
                              "password_confirmation",
                              $event.target.value
                            )
                          },
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "password-toggle",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: {
                        click: function ($event) {
                          _vm.showConfirmPassword = !_vm.showConfirmPassword
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.showConfirmPassword
                          ? "fi fi-eye-slash"
                          : "fi fi-eye",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.userData.password && _vm.userData.password_confirmation
                    ? _c("div", { staticClass: "password-match-indicator" }, [
                        _c("i", {
                          class: [
                            _vm.passwordsMatch ? "fi fi-check" : "fi fi-x",
                            _vm.passwordsMatch ? "text-success" : "text-danger",
                          ],
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.errors.password_confirmation
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.password_confirmation[0]) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block",
                  attrs: { type: "submit", disabled: _vm.isLoading },
                },
                [
                  _vm.isLoading
                    ? _c("span", { staticClass: "loading-spinner" })
                    : _vm._e(),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.isLoading ? "Creating Account..." : "Create Account"
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-footer" }, [
            _c(
              "p",
              { staticClass: "signin-link" },
              [
                _vm._v("\n        Already have an account?\n        "),
                _c(
                  "router-link",
                  {
                    staticClass: "link-primary",
                    attrs: { to: `/${_vm.currentLocale}/auth/login` },
                  },
                  [_vm._v("\n          Sign in here\n        ")]
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }